import { componentSizes, datePickTypes } from '@jdesign-vue/constants'
import type { ComponentSize, DatePickType } from '@jdesign-vue/constants'

export const isValidComponentSize = (val: string): val is ComponentSize | '' =>
  ['', ...componentSizes].includes(val)

export const isValidDatePickType = (val: string): val is DatePickType =>
  ([...datePickTypes] as string[]).includes(val)
